export default __webpack_public_path__ + "static/blog-header-dc77f36f046385e3ce2cbda7d90f25ba.svg";